<button mat-icon-button [routerLink]="['/iirds']" [queryParams]="{reset: true}" matTooltip="Change language" i18n-matTooltip>
  <mat-icon>translate</mat-icon>
</button>
